import React from 'react';
import styled from 'styled-components';

import Layout from 'components/Layout';
import { theme } from 'theme';

interface Props {
  children: React.ReactNode | React.ReactElement;
}

const SContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100% - ${theme.header.height});
  justify-content: center;
  text-align: center;
`;

const ErrorLayout = ({ children }: Props) => (
  <Layout>
    <SContainer>{children}</SContainer>
  </Layout>
);

export default ErrorLayout;
